/**
 * External Imports
 */
import { FC, RefObject, useCallback, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';

/**
 * Nexus Imports
 */
import {
  NeuButton
  // NeuFeedback
} from '@neutron/react';

/**
 * Internal Imports
 */
import { RootState } from '../../../../redux/store';
import { deleteTask, setToastType } from '../../../../redux/actions';

import { handleModal } from '../../../../services/ModalPortal/utils';
import useToast from '../../../../services/Toast';

/**
 * Global Type Definition Imports
 */
import { Feedback, Issue, TaskPost } from '../../../../config/interfaces';

interface IDeleteProps {
  loading: boolean;
  modalContentRef?: RefObject<HTMLElement | null>;
  task?: Feedback | Issue | TaskPost;
}

const DeleteBtn: FC<IDeleteProps> = ({ loading, modalContentRef, task }) => {
  const dispatch = useDispatch();

  const [rendered, setRendered] = useState(false);

  const { toast } = useToast();

  const handleDelete = useCallback(
    e => {
      e.stopPropagation();
      dispatch(setToastType('Delete Issue'));
      toast(
        `Are you sure you want to delete this ${task?.taskType}?`,
        'info',
        null,
        500,
        true,
        null,
        () => {
          if (task) {
            dispatch(deleteTask(task));
          }
        }
      );
    },
    [task]
  );

  useEffect(() => {
    setRendered(true);
  }, []);

  useEffect(() => {
    if (rendered && modalContentRef && !loading) {
      handleModal(modalContentRef);
    }
  }, [loading]);

  return (
    <NeuButton
      data-testid={`${task?.taskType?.toLowerCase() ?? ''}-delete-button`}
      kind="primary"
      color="red"
      size="small"
      style={{ textAlign: 'right' }}
      onClick={handleDelete}
    >
      {/* {loading ? <NeuFeedback aria-label="spinner" size="small" /> : ' */}
      Delete
      {/* '} */}
    </NeuButton>
  );
};

const mapReduxStateToProps = (state: RootState) => ({
  loading: state.TaskReducer.loadingDeleteTask,
  taskData: state.ModalReducer.modalData
});

export default connect(mapReduxStateToProps)(DeleteBtn);
